<div class="default-urgency-container" *ngIf="!isLoadingLabels">
	<div class="content-col-header">
		<span class="tab" [ngClass]="{ selected: selectedTab === 'urgency' }" (click)="selectedTab = 'urgency'">{{
			labels.lbl_geral_urgencia
		}}</span>
		<span class="tab" [ngClass]="{ selected: selectedTab === 'impact' }" (click)="selectedTab = 'impact'">{{
			labels.lbl_geral_impacto
		}}</span>
		<span class="tab" [ngClass]="{ selected: selectedTab === 'severity' }" (click)="selectedTab = 'severity'">{{
			labels.lbl_geral_severidade
		}}</span>
	</div>
	<div class="content-col" [ngStyle]="{ display: selectedTab === 'urgency' ? 'flex' : 'none' }">
		<register-default-urgency [labels]="labels"></register-default-urgency>
	</div>

	<div class="content-col" [ngStyle]="{ display: selectedTab === 'impact' ? 'flex' : 'none' }">
		<register-default-impact [labels]="labels"></register-default-impact>
	</div>

	<div class="content-col" [ngStyle]="{ display: selectedTab === 'severity' ? 'flex' : 'none' }">
		<register-form-impact-matrix></register-form-impact-matrix>
	</div>
</div>

<cpi-dot-bounce-loading-effect [color]="'var(--primary-color-1)'" *ngIf="isLoadingLabels"></cpi-dot-bounce-loading-effect>
